import { Report } from "@material-ui/icons";

const constants = {
  messages: {
    dataEmpty: "No Data Available.",
    dataEmptySearch: "Kindly search to get list of Application/ Websites to add Exception",
    futureDate: "Non-selectable",
    dayOff: "No data available"
  },
  datePicker: {
    apply: "Apply",
    cancel: "Cancel"
  },
  header: {
    profile: "Profile",
    account: "Account",
    feedback: "Feedback",
    myAccount: "My Account",
    logout: "Logout",
    exitFullScreen: "Exit Full Screen",
    fullScreen: "Full Screen"
  },
  dashboard: {
    heading: "Employee Details",
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email",
    department: "Department",
    phone: "Phone",
    address: "Address",
    city: "City",
    isActive: "IsActive",
    reset: "Reset",
    save: "Save",
    holidayList: "Holiday List",
    productive: 'Productive',
    unproductive: "Non-Core",
    nonCore: "Non-Core",
    idleTime: "Away Time",
    inTime: "In Time",
    outTime: 'Out Time',
    loggedIn: "Logged in",
    averageProductiveHrs: "Average Productive hrs",
    averageActiveHrs: "Average Active hrs",
    averageLoggedInHrs: "Average Logged in hrs",
    offlineTime: 'offline Time',
    hours: "Hours",
    dailyTrend: "Daily Trend",
    inOutTime: "In Out Time",
    dailyTimeLog: "Daily Time Log",
    dashboardOverview: "Dashboard Overview",
    attendanceSummary: "Attendance Summary",
    absenceReport: "Absence Report",
    topApplicationCategory: "Application / Web Category",
    topApplication: "Applications",
    topWebApps: "Websites",
    appWebsite: 'App / Website',
    myCalender: "My Calendar",
    attendanceHeatmap: "Attendance Heatmap",
    productiveApps: "Productive Applications",
    productiveWebsite: "Productive Websites",
    nonCoreApplication: "Non-Core Applications",
    assetDetails: "Asset Details",
    nonCoreWebsite: "Non-Core Websites",
    neutralApplications: "Neutral Applications",
    offlineTime: "Offline Time",
    timeSlide: 'Drag the slider to select active time',
    description: "Description",
    Productivity: "Productivity",
    application: "Applications",
    applicationWeb: "Applications / Websites",
    categories: "Categories",
    agentNotAvailable: " No time has been tracked because the TrakZo Agent is not running on your machine. Make sure it is downloaded for ",
    clickOnBarToAnalyze: "Click on bar to analyze Daily Time Log",
    popupHeader: "Antivirus Exception Recommendation",
    popupTextOne: "TrakZo makes a consistent effort to be white-listed among the various antivirus vendors. However, because of the powerful capabilities of our agent, we recommend setting up exceptions for TrakZo ",
    popupTextTwo: "Take a look at our ",
    popupTextFour: "to find out how to easily add exception. Chat with us or contact ",
    popupTextThree: "if you'd like us to assist you with deployment.",
    mostActiveProjects: 'Most Active Projects',
    mostActiveEmployees: 'Most Active Employees',
    utilizationChartForCurrentMonth: 'Utilization Chart for Current Month (Day Wise Count of Employees Assigned to Projects) ',
    holidayList: "Holiday List",
  },
  login: {
    signin: "Sign in",
    login: "Sign in",
    email: "Email",
    rememberMe: "Remember me",
    password: "Password",
    forgotPassword: "Forgot password?",
    signIn: "Login",
    companyName: 'TrakZo',
    welcome: 'Welcome to',
    signInContinue: "Login continue",
    copyRight: "Copyright © 2020-2021. All Rights Reserved.",
    website: "www.zoifintech.com",
    privacyPolicy: "Privacy Policy",
    developed: "Developed by:",
    termsofservice: "I agree to",
    registerationMeg: "Sign up and enjoy 15 day trial of our product",
    or: "OR",
    Alreadyhaveaccount: "Already have an account?",
    Register: "Register",
    signup: "Sign Up",
    submit: "Submit",
    confirmPassword: "Confirm Password",
    continue: "Continue",
    emailIDVerification: " Email Verification",
    AfterSubmitOTPWillBeTriggered: "* After form submit OTP will be triggered to Email",
    cancel: "Cancel",
    submit: "Submit",
    resendOTP: " Resend OTP",
    verifyOTP: "Verify OTP",
    changePassword: " Change Password",
    newPassword: "New Password",
    confirmNewPassword: 'Confirm New Password',
    submit: "Submit",
    confirmPassword: "Confirm Password",
    doyouhave: "Don't have an account? ",
    GetFree: "Get Started for Free",
    addPassword: "Reset Password",
    note: "Note ",
    verifyotpheader: "Enter 6 digit code to verify which is received on registered Email",
    UserID: "User ID"
  },
  path: {
    userlist: "/settings/userlist",
    report: "/reports",
    reportsList: "/reports/reportsList",
    activeuser: "/settings/userlist/active",
    inactiveuser: "/settings/userlist/inactive",
    edituser: "/settings/userlist/edituser",
    mergeduser: "/userlist/mergeduser",
    loginoptional: "/userverification/:id",
    adduser: "/settings/userlist/adduser",
    login: "/",
    dashboard: "/dashboard",
    capacityPlan: '/myTeam/organizationstructure',
    mycalender: "/mycalendar",
    reports: "/reports",
    timereport: "/reports/timereport",
    summaryreport: "/reports/summaryreport",
    detailedreport: "/reports/detailedreport",
    userdetail: "/userdetail",
    addEmployee: "/addemployee",
    viewEmployee: "/viewemployee",
    executiveSummary: "/myTeam/executiveSummary",
    myTeam: "/myTeam",
    deepDive: "/myTeam/deepDive",
    systemResources: "/myTeam/systemResources",
    appConfig: "/settings/appConfig",
    applicationCategory: "/settings/appConfig/applicationCategory",
    appProductivity: "/settings/appConfig/manageException",
    application: "/settings/appConfig/application",
    organization: "/settings/organization",
    projectupdate: "/settings/projectupdate",
    Capacity: "/settings/Capacity",
    agentConfiguration: "/settings/agentConfiguration",
    billing: "/settings/billing",
    myAccount: "/settings/myAccount",
    settings: "/settings",
    licenceUpload: "/settings/licenseUpload",
    licence: "/settings/license",
    screenShotConfig: "/screenshots/Configuration",
    screenShotList: "/screenshots/Lists",
    download: "/settings/download",
    payment: "/settings/payment",
    offlineTime: "/offlinetime",
    RestrictedAppUsage: "/settings/RestrictedAppUsage",
    smtp: "/settings/smtp",
    offlineTimeRequest: "/offlinetime/request",
    offlineTimeLog: "/offlinetime/log",
    offlineTimeReport: "/reports/offlineTime",
    Departmentsummaryreport: "/reports/Departmentsummaryreport",
    EmployeeHolidayWorkingHours: "/reports/EmployeeHolidayWorkingHours",
    attendanceReports: "/reports/attendanceReports",
    Employeesummaryreport: "/reports/Employeesummaryreport",
    employeeLeaveReport: "/reports/EmployeeLeaveReport",
    timeSheet: "/myTeam/timeSheet",
    myDashboard: "/myTeam/timeSheet/timeSheetDashboard",
    leave: "/settings/leave",
    dashboardDelegation: "/settings/dashboardDelegation",
    Worktimeconfiguration: "/settings/WorkTime/Worktimeconfiguration",
    workTime: "/settings/WorkTime",
    overTimeRules: "/settings/WorkTime/OverTimeRules",
    createOverTimeRules: "/settings/WorkTime/CreateOverTimeRules",
    trakzolive: "/trakzolite",
    mailSchedular: "/settings/mailSchedular",
    genericHoliday: "/settings/genericHoliday",
    attendance: "/myTeam/attendance",
    capacityPlanning: "/myTeam/capacityPlanning",
    itam: "/assetReports",
    softwaredetails: "/assetReports/softwaredetails",
    unmappedApplication: "/assetReports/unmappedApplication",
    skippedApplication: "/assetReports/skippedApplication",
    hardwreReports: "/assetReports/hardwreReports",
    hardwareDetails: "/assetReports/hardwareDetails",
    licenseStatistics: "/assetReports/licensestatistics",
    reportsAsset: "/assetReports/report",
    installedapplications: "assetReports/installedapplications",
    userreports: "/assetReports/ITAMDashboard/userreports",
    userdetailsreport: "/assetReports/userdetailsreport",
    userwiseDetailsReport: "/assetReports/ITAMDashboard/userreports/userdetailsreport",
    ITAMDashboard: '/assetReports/ITAMDashboard',
    viewSoftwareDetails: "/assetReports/ITAMDashboard/viewsoftwaredetails",
    employeeApplicationReport: "/reports/employeeApplicationReport",
   
  },
  CustomEvent: {
    In: "In :",
    Out: "Out :",
    Total: "Total :",
    pTotal: "Prod :",
    aTotal: "Active :",
    DayOff: "Day Off"
  },
  card: {
    time: "1.Employee Time Data",
    timeText: "Give an overview of the total amount of time spent by employees over a specified time",
    summary: "2.Application Summary Data",
    summaryText: "Give an overview of the total amount of time spent by employees over a specified time",
    report: "3.Application detailed Report",
    reportText: "Give an overview of the total amount of time spent by employees over a specified time",
  },
  datePickerLabel: {
    fromDateLabel: "From Date",
    toDateLabel: "To Date",
    margin: "normal",
    fromDateId: "from-date-dialog",
    toDateId: "to-date-dialog",
    format: "MM/dd/yyyy",
    hourlySpread: "Hourly Spread",
    utilizationVsTarget: "Utilization Vs Target",
    top10Productive: 'Top 10 Productive',
    least10Productive: "Least 10 Productive",
    date: "Date",
  },
  capacity: {
    header: "Organization Structure",
    skill: 'Skill',
    capacityPlanning: 'Capacity Planning',
    weeklytrend: 'Weekly Trend',
    dailytrend: 'Daily Trend',
    pleaseSelect: 'Please Select',
    module: 'Module',
    project: 'Project',
    user: 'User',
    PleaseEnter:'Please Enter',
    user: 'User',
    EstHrs:'Est.Hrs'

  },
  userdetail: {
    header: "User Detail",
    adduser: "Add User",
    edituser: "Edit User",
    fname: "First Name",
    lname: "Last Name",
    email: "Email",
    mobile: "Mobile",
    empcode: "EMP Code",
    team: "Team",
    businessunit: "Business Unit",
    department: "Department",
    designation: "Designation",
    workingday: "Working Days",
    workinghours: "Working Hours",
    download: "Download Agent",
    edit: "Edit Details",
    name: "Name"

  },
  userdetailReports: {
    systemname: "System Name",
    username: "User Name",
    active: "Active ",
    viewhistory: "View History",
    inactive: "Inactive",
    summary: "Summary",
    otheruser: "Other Users of this system list",
    keyboard:"Keyboard",
    OS: "OS",
    manufacture: "Manufacturer",
    modeldetails: "Model Details",
    computertype: "Computer Type",
    Processor: "Processor",
    physicalmemory: "Physical Memory",
    noofapplications: "No of Applications",
    installedApplications: "Installed Applications",
    computerType:"Computer Type",
    antivirus:"Antivirus",
    drive:"Drive",
    scanSummary:"Scan & IP Summary",
    monitor:"Monitor"
  },
  softwaredetailss: {
    publisher: "Software Publisher",
    publishers: "Top 20 Software Publishers",
    operating: "Operating Systems",
    viewSoftwareDetails: "Software Details",
    Manufactures: "Manufacturer",
    Antivirus: "Antivirus",
    SystemType: "System Type",
  },
  reportAsset: {
    hardwareReport: "Hardware Report",
    softwarebyComputerReport: "Software by Computer Report",
    windowsLaptopDesktopReport: "Windows Laptop Desktop Report",
    OSOverview: "OS Overview",
    licenseStaticsReport: "License Statics Report",
    hardwaredescription: "Gives Overview of system wise Hardware Details in system",
    softwareByComputerDescription:"Gives Overview of system wise Software details Installed",
    laptopDeskTopReportDescription:"Gives Overview of laptop and Desktop systems Software and Hardware Data",
    osOverviewReportDescription:"Gives Overview of systems with OS details and basic machine details",
    licenseStaticsReportDescription:"Gives Overview of installed applications with license Available"
  },
  userlist: {
    active: "Active",
    inactive: "Inactive",
    UnauthorizedAgents: "Unauthorized Agents",
    trakzoLite: "TrakZo Lite",
    merged: "Merged",
    searchUser: "Search User...",
    newuser: "New User",
    existuser: "Existing User",
    sendMail: " Send an email invite to user",
    superUser: " Super User can view all users data in the organization",
    isAdmin: " Admin can export report and configuration changes in TrakZo Portal"
  },
  billingandplan: {
    subscribe: "My Subscriptions",
    translation: "My Transactions"
  },
  myTeam: {
    myTeamDashboard: "My Team Dashboard",
    executiveSummary: "Executive Summary",
    deepDive: "Deep Dive",
    absenseReport: "Absence Report",
    systemResources: 'System Resources',
    dayWiseTimeLog: "Day Wise Time Log",
    averageLoggedInHrs: "Average Logged In Vs Active Vs Productive Hours",
    dailyInOutTrend: "Daily In/Out Trend",
    loggedInHrs: "Logged In Vs Active Vs Productive Hours",
    compareDifferentGroups: "Compare Different Groups",
    timeSpentInApplications: "Time Spent In Applications & Website",
    topApplication: 'Top Application',
    topWebsite: "Top Website",
    applicationVsWebsites: "Application Vs Websites",
    applicationTimeSplit: "Application (Prod., Non-Core., Away)",
    websitesTimeSplit: "Websites (Prod., Non-Core., Away)",

    attendanceHeatmap: "Attendance Heatmap",
    hourlySpread: "Hourly Spread",
    HourlyApplication: 'Hourly Application Wise User Count',
    websiteCategory: "Website Category",
    applicationGroup: "Application Group - More Details",
    websiteGroup: "Website Group - More Details",
    applicationCategory: 'Application Category',
    utilizationVsTarget: "Utilization Vs Target",
    top10Productive: 'Top 10 Productive',
    least10Productive: "Least 10 Productive",
    UserCount: "User Count",
    DepartmentName: "Department Name",
    NoncoreActivity: "Non-Core Activity :",
    Productive: "Productive :",
    hrs: "hrs",
    WorkTime: "Work Time",
    search: "Search",
    Users: "Users",
    UserName: "User Name",
    monthWiseTrend:"Month Wise Time Trend",
    weekWiseTrend:"Weekday Wise Time Trend",
    application:"Application",
    website:"Website",
    avgApplicationWebisteActiveTime:"Average Application/Website Active Time"
  },
  dropDown: {
    teamLabel: "Team",
    groupLabel: "Department",
    BusinessLabel: "Business Unit",
    Loading: "Loading",
    groupData: [{ name: "None", value: "1" }, { name: "IT", value: "2" }],
    teamData: [{ name: "None", value: "1" }, { name: "IT", value: "2" }]
  },
  autoComplete: {
    id: "auto-complete",
    label: "Search User *",
    searchUser: "Search User",
    searchuser: "Search User",
    user: "Users",
    margin: "normal",
    loading: "Search User...",
    labelDropDown: "Search Application *",
    labelApplication: "Application",
    loadingDropdown: "Search Application..."
  },
  file: {
    pdfLabel: "PDF",
    csvLabel: "csv",
    reportHeader: "Reports Overview",
    reports: "Reports",
  },
  report: {
    download: "Download",
    pending: "Report under process",
    error: "Unable to Generate Report",
    reportTablehHeader: "Generated Report Log"
  },
  user: {
    error: "Please search and select user"
  },
  application: {
    error: "Please search and select application"
  },
  button: {
    name: "Generate",
    label: "Generate",
    variant: "contained",
    update: "Update",
    cancel: "Cancel",
    upload: "Upload",
    submit: "Submit",
    reset: "Reset"
  },
  userdetail: {
    header: "User Detail",
    adduser: "Add Invite for New User",
    edituser: "Edit User",
    fname: "First Name",
    lname: "Last Name",
    email: "Email",
    mobile: "Mobile",
    empcode: "EMP Code",
    team: "Team",
    searchUserReuired: "Search User *",
    teamrequired: "Team*",
    businessunit: "Business Unit",
    department: "Department",
    designation: "Designation",
    workingday: "Working Days",
    workinghours: "Working Hours",
    download: "Download Agent",
    edit: "Edit Details",
    role: "Job Role",
    name: "Name",
    Hostname: "Hostname",
    AccountName: "Account Name",
    SendEmail: "Send Email",
    Upload: "Multiple Authorized Agents",
    editApplication: "Edit Application",
    addCategory: "Add Category",
    SystemId: "System Id",
    Location: "Location",
    ruleName: "Rule Name ",
    selectRule: "Select Rule *",
    ruleNameRequired: "Rule Name *",
    addCategory: "Add Category",
    categoryName: "Category Name",
    userUpload:"User Upload",
    inactivateUserUpload:"Inactivate Bulk User Upload"
  },
  organization: {
    header: "Organization",
    institutionName: "Company Name",
    website: "Website",
    contactEmail: "Contact Email",
    timeZone: "Timezone",
    country: "Country",
    fileError: "Please upload image format of jpg or png or jpeg"
  },
  genericHoliday: {
    header: "Generic Holiday",
    holidayDescription: "Description",
    holidayDate: "Date"
  },
  license: {
    button: "SUBSCRIBE NOW",
    message: "Free trial has Expired",
    uploadLicense: "Upload License",
    manageLicense: "Manage License",
    uploadPGPFile: "Upload .PGP File",
    uploadCSV: "Upload .CSV File",
  },
  leave: {
    leave: "Leave and Holiday Management",
    month: "Select Month *",
    year: 'Select Year *',
    uploadFile: "Upload File",
    dataWillReprocessed: "Data will reprocessed in EOD Scheduler.",
    search: "Search..."
  },
  timeSheet: {
    timeSheet: "Time Sheet"
  },
  assetRepots: {
    assetReports: "Asset Reports",
    softwareDetails: "Software Details",
    category: "Category",
    vendor: "Vendor",
    skippedApplication: "Skipped Applications",
    UnMappedApplications: "Unmapped Applications",
    hardwareReports: "Dashboard Reports"
  },
  attendance: {
    attendance: "Attendance",
    thresHoldTooltip: "Threshold represents number of minutes employee must work in a day",
  },
  trakzolive: {
    trakzolive: "TrakZo Lite"
  },
  licenseSubscribe: {
    button: "SUBSCRIBE",
    message: "13 Days Left for trial Period"
  },
  myAccount: {
    heading: "My Account",
    lastTransaction: "Transaction Details",
    subscriptionDetails: "Subscription Details",
    billingDetails: "Billing Details",
  },
  dashboardDelegation: {
    dashboardDelegation: "Dashboard Delegation",
    businessUnit: "Business Unit Wise",
    groupWise: "Group Wise (Department)",
    roleWise: "Role Wise",
    reportingWise: "Reporting Wise",
    userWise: " User Wise",
    selectDelegate: "Select Delegate *"

  },

  agentConfiguration: {
    header: "Agent Configuration",
    hardware: "Hardware Capture",
    software: "Software Capture",
    idleTime: "Idle Time Interval *",
    activityDataSync: "Activity Data Sync *",
    offlineTime: "Offline Time *",
    idleTimeTooltip: "Idle Time Interval",
    activityDataSyncTooltip: "Activity Data Sync",
    offlineTimeTooltip: "Offline Time",
    privateTime: "Enable private time",
    Enablescreenshot: "Enable screenshot",
    privateTimeNote: "Agent Configuration will be updated to agent in approximate 30 mins",
    Enablescreenshot: "Enable screenshot",
    EnablescreenshotNote: "Enable screenshot",
    hardwareSoftwareCapture: "Hardware Software Capture"
  },
  mailSchedular: {
    scheduleFrequency: "Schedule Frequency *",
    reportName: "Report Name *",
    format: "Format *",
    emailDetails: "Email Details *",
    enabled: "Enabled",
    scheduleName: "Schedule Name",
    header: "Mail Scheduler",
    daysOfMonth: "Day Of Month",
    ReportnameTooltip: "Mail subject line will consist report name and period of the report generated"
  },
  mySubscription: {
    monthly: "Monthly",
    yearly: "Yearly"
  },
  billingSummary: {
    user: "Users",
    subscribed: "Subcribed",
    used: "Used",
    billing: "Billing",
    subscribtionType: "Subscription Type",
    standard: "Standard",
    paymentMethod: "Payment Method",
    Monthly: "Monthly",
    Yearly: "Yearly",
    freePlan: "TRIAL",
    freeUser: "Free For Upto 3 Users",
    standardPlan: "STANDARD",
    standardMoney: "₹179",
    standardUser: "Per Month Per User",
    standardYearUser: "Per Year Per User",
    proPlan: "PRO",
    proMoney: "₹8955",
    proPopular: "Most Popular",
    enterprisePlan: "ENTERPRISE SOLUTION",
    enterpriseUser: "Tailor-made for You",
    trialMessage: "15 Days Free Trial"
  },
  RestrictedAppUsage: {
    header: "Restricted App Usage",
    email: "Email Id(s) *",
    application: "Select Application *"
  },
  worktime: {
    header: "Work Time Configuration",
    subHeader: "Overtime Rate",
    workTime: "Work Time Configuration",
    filter: "Filter",
    activityType: "Activity Type",
    ruleName: "Rule Name",
    ruleNameRequired: "Rule Name *",
    weeklyHours: "Weekly Hours",
    dailyHours: "Daily Hours",
    otSlab1Rate: "OT Slab 1 Rate",
    otSlab2Rate: "OT Slab 2 Rate",
    otSlab3Rate: "OT Slab 3 Rate",
    otSlab4Rate: "OT Slab 4 Rate",
    overtimeDate: "Overtime Period Ends",
    fixedAmount: "Fixed Amount",
    PerOfBasicPay: "Per of Basic Pay",
    workingDays: "Working Days",
    holiday: "Holiday",
    enableOvertime: "Enable Overtime",
    overtimeRule: "Overtime Rule",
    overtimeFactor: "Overtime Factor",
    overtimeValidTill: "Overtime Valid Till",
    assignOverTimeRules: 'Assign Over Time Rules',
    createOverTimeRules: 'Create Over Time Rules',
    overTime: "Assign OT Rules",
    createOverTime: "Create OT Rules",
    aboveSlab: "Above Slab 1"
  },
  screenShotConfig: {
    header: "Screenshot Configuration",
    fromDatetime: "From DateTime *",
    toDatetime: "To DateTime *",
    minutes: "Minutes",
    images: "Images",
    fromDateValidation: "From DateTime should be 10 minute after from now",
    toDateValidation: "To DateTime should be  5 minute after From DateTime",
    fromDateRequired: "Please select From DateTime",
    toDateRequired: "Please select To DateTime",
    searchUser: "Search User",
    listHeader: "Screenshot List",
    addRequestButton: "Add Request",
    zoomInstruction: "Use the mouse scroll for zoom",
    Screenshotfrequencyforevery: "Screenshot frequency for every *",
    SearchUserMandantry: "Search User *",
    LoadingSearchUser: "Search User...",
    loading: "Loading...",
    UserName: "User Name:",
    ScreenshotDate: "Screenshot Date:",
    next: ">",
    prev: "<",
    Usemousescrollforzoom: "Use mouse scroll for zoom",

  },
  settings: {
    content: {
      usermanagement: "User Management",
      agentsetting: "Agent Configuration",
      holidayMaster: "Generic Holiday",
      organizationsetting: "Organization Settings",
      billingplans: "Billing & Plans",
      download: "Downloads",
      applicationconfiguration: "Application Configuration",
      screenShot: "Screenshot Configuration",
      RestrictedAppUsage: "Restricted App Usage",
      License: "License",
      smtp: "SMTP Configuration",
      leave: 'Leave and Holiday Management',
      worktime: "Work Time Configuration",
      smtp: "SMTP Configuration",
      dashboardDelegation: "Dashboard Delegation",
      mailSchedular: "Mail Schedule",
      ganttChart: "Project Plan"
    },
    toast: {
      success: "Success",
      failure: "Failure",
      failureWrong: "Something went wrong",
      file: "File Downloaded Successfully"
    },
    validation: {
      user: "Please Select User"
    },
    appConfig: {
      applicationCategory: 'Application Category',
      appProductivity: 'Manage Exception',
      Application: 'Applications',
      appConfig: "Application Configuration",
      searchHere: "Search here",
      searchApplications: "Search Applications / Websites",
      searchCategory: "Search Category",
      searchWeborApp: "Search Application / Website",
      alwaysActive: "Always Active",
      SelectMaximumAwayTime: 'Select Maximum Away Time',
      department: "Department",
      departmentWise: "Department Wise",
      applicationType: "Application Type",
      searchUser: "Search...",
      addException: "Add Exception",
      userWise: "User Wise",
      areYouSureYouWantToDelete: "Are you sure you want to delete  ",
      unauthorize: "Are you sure you want to unauthorize ",
      removeFromThisCategory: "Remove from this Category",
      move: "Move",
      moveApplication: "Move Application",
      displayName: "Display Name",
      applicationCategoryList: "Application Category",
      search: "Search Employee Name",
      seachAll: 'Search...',
      doYouWantToRemoveAlwaysActive: "Do You Want To Remove Always Active",
      addCategory: "Add Category",
      all: "All",
      custom: "Custom",

    }
  },
  stepper: {
    Registration: "Sign up",
    signup: "Sign Up",
    verifyemail: 'Verify Email',
    downloadandinstall: 'Download & install'
  },
  payment: {
    planSummary: "PLAN SUMMARY",
    changePlan: "CHANGE PLAN",
    billingPeriod: "Billing period",
    userCount: "User Count",
    monthly: "Monthly",
    peruser: "Per User",
    vat: "VAT",
    total: "Total",
    addPayment: "Add Payment Method"
  },
  firebaseScreen: {
    dashboard: "Dashboard",
    calendar: "Calendar",
    download: "Download",
    billingandplan: "BillingAndPlan",
    payment: "Payment",
    appconfig: "AppConfig",
    applicationconfig: "ApplicationConfigTab",
    manageexception: "ManageException",
    systemresource: "SystemResource",
    deepdive: "DeepDive",
    executesummary: "ExecuteSummary",
    organization: "Organization",
    license: "License",
    applicationdetailedreport: "ApplicationDetailedReport",
    applicationsummarydata: "ApplicationSummaryData",
    employeetimedata: "EmployeeTimeData",
    screenshotconfig: "ScreenShotConfig",
    screenshotlist: "ScreenShotList",
    setting: "Settings",
    userlist: "User List",
    userprofile: "UserProfile",
    agentConfiguration: "agentConfiguration",
    RestrictedAppUsage: "RestrictedAppUsage",
    smtp: "SMTPConfiguration",
    timeSheetDashboard: "TimeSheetDashboard",
    applicationList: "ApplicationList",
    licence: "License",
    leave: "Leave",
    timeSheet: "timeSheet",
    attendance: "attendance",
    reports: "Reports",
    offlineTimeRequest: "offlineTimeRequest",
    offlineTimeHistory: "offlineTimeHistory",
    WorkTimeconfiguration: "Work Time configuration",
    overTimeRules: "Over Time Rules",
    dashboardDelegation: "Dashboard Delegation",
    trakzolite: "TrakZo Lite",
    skippedApplication: "Skipped Application",
    assetReports: "Asset Reports",
    unmappedApplication: "Unmapped Application",
    assetReportDashboard: "assetReportDashboard",
  },
  firebaseScreenCLick: {
    loginClick: "login click",
    socialMedia: "social media",
    forgetPassword: "forget password",
    registerScreen: "free register",
    sendOtp: "sendotp",
    verifyOtp: "verifyotp",
    changePassword: "change password",
    register: "register",
    dashboardDailyTimeLog: "time log switch",
    swicthProductive: "productive Switch",
    calendarChange: "calendar change date",
    calendarDateClick: "calendar select date",
    employeetimedataSubmit: "EmployeeTimeDataSubmit",
    employeeLeaveDataSubmit: "EmployeeLeaveDataSubmit",
    applicationdetailedreportSubmit: "ApplicationDetailedReportSubmit",
    applicationsummarydataSubmit: "ApplicationSummaryDataSubmit",
    screenshotconfigSubmit: "ScreenShotConfigSubmit",
    agentConfigurationSubmit: "agentConfigurationSubmit",
    organizationSubmit: "OrganizationSubmit",
    selectedCategory: "selectedCategory",
    ApplicationdeleteCategory: "ApplicationdeleteCategory",
    productive: "productive",
    smtp: "Test SMTP",
    smtpUpdate: "Update SMTP",
    addCategory: "Add Category",
    updateApplicationActiveTime: "Update Application Active Time",
    moveApplication: "Move Application",
    removeAlwaysActive: "Remove Always Active",
    deleteApplication: "Delete Application",
    UpdateDisplayName: "Update Display Name",
    DeleteDisplayName: "Delete Display Name",
    unsubscribeClick: "Un Subscribe User",
    multiUpload: "Authorized Agent Upload",
    handleAuthorize: "Authorize",
    handledelete: "Handle Delete",

    selectSingleEmployee: "Select Single Employee"
  },
  Price: {
    StandardMonthly: "₹199",
    StandardYearly: "₹1,911",
    StandardMonthlyDollar: "$3",
    StandardYearlyDollar: "$29",
    ProMonthly: "₹299",
    ProYearly: "₹2,871",
    ProMonthlyDollar: "$5",
    ProYearlyDollar: "$48"
  },
  PageTitle: {
    login: "TrakZo",
    dashboard: "TrakZo - Dashboard",
    calendar: "TrakZo - Calendar",
    download: "TrakZo - Download",
    billingandplan: "TrakZo - Billing & Plan",
    payment: "TrakZo - Payment",
    appconfig: "TrakZo - App Config",
    applicationconfig: "TrakZo - Application Config",
    manageexception: "TrakZo - Manage Exception",
    systemresource: "TrakZo - System Resource",
    deepdive: "TrakZo - Deep Dive",
    absenceReport: "TrakZo - Absence Report",
    executesummary: "TrakZo - Team Dashboard",
    organization: "TrakZo - Organization",
    applicationdetailedreport: "TrakZo - Application Detailed Report",
    applicationsummarydata: "TrakZo - Application Summary Data",
    employeetimedata: "TrakZo - Employee Time Data",
    employeewiseSummary: "TrakZo - Employeewise Summary",
    departmentsummaryreport: "TrakZo - Department Summary",
    employeeHolidayWorkingHours: "TrakZo - Employee Holiday Working Hours",
    offlineTime: "TrakZo - Offline Time",
    screenshotconfig: "TrakZo - Screenshot Config",
    screenshotlist: "TrakZo - Screenshot List",
    setting: "TrakZo - Settings",
    userlist: "TrakZo - User List",
    userprofile: "TrakZo - UserProfile",
    agentConfiguration: "TrakZo - Agent Configuration",
    offlineTime: "Trakzo - Offline Time",
    smtp: "SMTP Configuration",
    RestrictedAppUsage: "TrakZo - Restricted App Usage",
    application: "TrakZo - Application",
    License: "TrakZo - License",
    Leave: "TrakZo - Leave",
    timeSheet: "TrakZo - Time Sheet",
    attendance: "TrakZo - Attendance",
    reports: "TrakZo - Reports",
    WorkTime: "TrakZo - Work Time configuration",
    overTimeRules: "TrakZo - Over Time Rules",
    DashboaedDelecation: "TrakZo - Dashboard Delegation",
    addUsers: "TrakZo - Add User",
    trakzolive: "TrakZo - Lite",
    mailSchedular: "TrakZo - Mail Schedular",
    myAccount: "TrakZo - My Account",
    assetReports: "TrakZo - Software Details",
    unmappedApplication: "TrakZo - Unmapped Application",
    skippedApplication: "TrakZo - Skipped Application",
    assertReportDashboard: "TrakZo - Assert Report Dashboard",
    licenseStatistics: "TrakZo - License Statistics",
    ItamDashBoard: "TrakZo - ITAM Dashboard",
    viewSoftwareDetails:"TrakZo - Software Details",
    UserwiseDetails:"TrakZo - User wise Details",
    organizationStructure: "TrakZo - Organization Structure",
    capacityPlanning: "TrakZo - Capacity Planning",
  },
  paymentInfo:
  {
    Billedto: "Billed to",
    InvoiceEmail: "Invoice Email",
    PhoneNumber: "Phone Number",
    CompanyRegistrationNumber: "Company Registration Number",
    VATGSTTaxNumber: "VAT / GST/ Tax Number",
    Country: "Country",
    Address: "Address",
    Button: "Save payment method",
    UpdateButton: "Update payment method",
    PLANSUMMARY: "PLAN SUMMARY",
    CHANGE: "CHANGE",
    Billingperiod: "Billing period",
    UserCount: "User count",
    Peruser: " User p.m",
    Total: "Total",
    UpdateSubscription: "Update Subscription",
    SELECTPAYMENTMETHOD: "SELECT PAYMENT METHOD",
    BILLINGDETAILS: "BILLING DETAILS",
    details: "If you have any query please feel free to contact ",
    email: "team@zoifintech.com"
  },

  common: {
    comingsoon: "Coming soon",
    nooption: "No Options",
    loading: "Loading...",
    dateValid: "To Date should be greater than from date",
    dateTimeValid: "To Date-Time should be greater than from date",
  },
  download: {
    zip: ".ZIP",
    exe: ".EXE",
    apple: "Mac",
    linux:"Linux",
    successMessage: "Email ID Verified Successfully",
    headerOne: "We have sent an email to your ",
    registeredemail: "registered email",
    headerTwo: ", please verify and start using our product",
    headerText: "You may now download your TrakZo Agent and sign in with your email address and password.",
    download: "You may now download your TrakZo Agent and sign in with your email address and password."
  },
  filter: {
    selectGroup: "Select Group"
  },
  smtp: {
    header: "SMTP Configurations",
    SenderEmail: "Sender Email",
    HostServer: "Host Server",
    PortNumber: "Port Number",
    UserName: "User Name",
    Password: "Password",
    TestSMTP: "Test SMTP",
    update: "Update"
  },
  offlineTime: {
    header: "Offline Time",
    request: "Request",
    log: "History"
  },
  categories: {
    Category: "Category"
  },
  assetDetails: {
    systemName: "System Name",
    loginName: "Login Name",
    installedOn: "Agent Installed On",
    lastdataCapturedOn: "Last Data Captured On",
  },
  unCategorizedApplication: 26,

  employeeDetails: {
    expertise: 'Expertise',
    technical: 'Technical',
    functional: 'Functional',
    employeeDetailsUpdated: 'Employee Details updated successfully',
    skillUpdated: 'Skillset updated successfully',
    plzEnterSkill: 'Please enter Skill',
    plzEnterMonth: 'Please enter Months',
    plzEnterSkillset: 'Please enter Skillset',
    ageRestrictions: 'Employment Age should between 18 to 65',
    plzEntertheDOJ: 'Please enter DOJ',
    plzEntertheDOB: 'Please enter DOB',
    plzEntertheCPH: 'Please enter Cost per Hour',
    plzEntertheValidCPH: 'Please enter valid Cost per Hour',
    employeeName: 'Employee Name',
    year: 'Year',
    month: 'Month',
    costPerHour: 'Cost per hour',
    skillSet: 'Skillset',
    btnUpdate: 'Update',
    btnAdd: 'Add'
  },

  userReports: {
    userwiseDetailsReport: 'Userwise Details',
    summary: 'Summary',
    installedApplications: 'Installed Applications'
  },
  capacityPlanning: {
    Dashboard: "Dashboard",
    EmployeeView: "Employee View",
    ProjectView: "Project View",
    EmployeeDetails: "Employee Details",
    CapacityUtilization: "Capacity Utilization",
    UtilizationHrs: 'Utilization Hrs',
    LoggedHrsPer: 'Logged in Hrs',
    ProductiveHrs: 'Productive Hrs'
  },
  projectView: {
    task: 'Task',
    estDate: 'Est Date',
    estHrs: 'Est Hr(s)',
    hrs: 'Hr(s)',
    min: 'Min(s)',
    assigned: 'Assigned',
    update: 'Update',
    complete: 'Complete',
    totalTime: 'Total Time Spent',
    pleaseEnter: 'Please enter',
    date: 'Date',
    pleaseSelect: 'Please select',
    timespent: 'Time Spent'
  }


}


export default constants;
